"use strict";
/*
 * For:
 *    tracking clicks on social-media links (Footer and SocialMedia Components)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.socialMediaLinkComponent = exports.SocialMediaLinkCheckerComponent = void 0;
const app_1 = require("app");
class SocialMediaLinkCheckerComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.social__links a';
    }
    OnInit() {
        // skip code execution if dataLayer is not set
        if (!(0, app_1.isDataLayerSet)()) {
            return;
        }
        this.el.forEach((el) => {
            el.addEventListener('click', () => {
                const href = el.getAttribute('href');
                const socialChannel = el.getAttribute('data-social-channel');
                app_1.GTM.socialLinks({
                    channel: socialChannel,
                    link: href,
                });
            });
        });
    }
}
exports.SocialMediaLinkCheckerComponent = SocialMediaLinkCheckerComponent;
exports.socialMediaLinkComponent = new SocialMediaLinkCheckerComponent();
